var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-to-top-btn-container",on:{"click":_vm.scrollToTop}},[_c('Icons',{staticStyle:{"--icon-size":"18px"},attrs:{"name":"arrow","rotate":90}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.scrollToTopText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }